import { isNil } from 'lodash'
import { union } from '@wix/wix-data-client-common/dist/esm/infra/unionType'
import Maybe from 'folktale/maybe'

const FilterExpression = union('FilterExpression', {
  ByCurrentUser: ({ field, condition }) => ({ field, condition }),
  ByValue: ({
    field,
    condition,
    value,
    path,
    referencedValue = Maybe.Nothing(),
  }) => ({ field, condition, value, path, referencedValue }),
  ByDataset: ({
    field,
    condition,
    dataset,
    datasetField,
    filterId,
    path,
    datasetFieldIsArray,
  }) => ({
    field,
    condition,
    dataset,
    datasetField,
    filterId,
    path,
    datasetFieldIsArray,
  }),
  ByUserInput: ({
    field,
    condition,
    component,
    filterId,
    componentType,
    componentValueIsArray,
  }) => ({
    field,
    condition,
    component,
    filterId,
    componentType,
    componentValueIsArray,
  }),
  BySlug: ({ field, slug, condition }) => ({
    field,
    slug,
    condition,
  }),
})

FilterExpression.of = function (filterExpression) {
  if (filterExpression.field === '_owner') {
    return FilterExpression.ByCurrentUser(filterExpression)
  }
  if (!isNil(filterExpression.dataset)) {
    return FilterExpression.ByDataset(filterExpression)
  }
  if (!isNil(filterExpression.component)) {
    return FilterExpression.ByUserInput(filterExpression)
  }
  if (!isNil(filterExpression.slug)) {
    return FilterExpression.BySlug(filterExpression)
  }
  return FilterExpression.ByValue({
    ...filterExpression,

    referencedValue: filterExpression.staticMultiRef
      ? Maybe.Just(filterExpression.referencedValue)
      : Maybe.Nothing(),
  })
}

FilterExpression.get = function () {
  return this.matchWith({
    ByCurrentUser: ({ field, condition }) => ({ field, condition }),
    ByValue: ({ field, condition, value, path }) => ({
      field,
      condition,
      value,
      path,
    }),
    ByDataset: ({
      field,
      condition,
      dataset,
      datasetField,
      filterId,
      path,
      datasetFieldIsArray,
    }) => ({
      field,
      condition,
      dataset,
      datasetField,
      filterId,
      path,
      datasetFieldIsArray,
    }),
    ByUserInput: ({
      field,
      condition,
      component,
      filterId,
      componentValueIsArray,
    }) => ({
      field,
      condition,
      component,
      filterId,
      componentValueIsArray,
    }),
    BySlug: ({ field, condition, slug }) => ({ field, condition, slug }),
  })
}

export default FilterExpression
